import { Link } from "react-router-dom";
import styles from "./style.module.scss";

type HeaderLinkProps = {
  linkText: string,
  icon: string,
  iconAlt: string,
  to: string
};

const HeaderLink = (props: HeaderLinkProps) => {
  const { linkText, icon, to, iconAlt } = props;

  return (
    <Link className={styles.link} to={to}>
      <img className={styles.icon} src={icon} alt={iconAlt} />
      {linkText}
    </Link>
  )
}

export default HeaderLink;